// extracted by mini-css-extract-plugin
module.exports = {"Loader":"loader_Loader__1jHwz","loader_container":"loader_loader_container__5hubi","load":"loader_load__3-pRg"};